import Abcjs from './abcjs';
import React from 'react';
import { abcClefModifier } from '../lib/abcClef';
import { note, transpose } from "@tonaljs/core";
import { scientificToAbcNotation } from "@tonaljs/abc-notation";

// Bass clef sits exactly two octaves lower than treble clef for the same staff
// position (see the matching shift in notes.js), so chord/scale tones need the
// same shift here to land within the instrument's actual playable range instead
// of always being built around the treble-clef default octave.
const BASS_CLEF_OCTAVE_SHIFT = "-15P";

// Trombone's (and other bass-clef instruments') practical lowest note is the E
// notated on the first ledger line below the staff (E2). If the shift above
// pushes any note below that, shift the whole set back up an octave instead of
// leaving it under playable range.
const LOWEST_BASS_CLEF_MIDI = note("E2").midi;

const shiftToBassClefRange = (notes) => {
  const shifted = notes.map(n => transpose(n, BASS_CLEF_OCTAVE_SHIFT));
  const tooLow = shifted.some(n => note(n).midi < LOWEST_BASS_CLEF_MIDI);
  return tooLow ? shifted.map(n => transpose(n, "8P")) : shifted;
};

const AbcNotation = ({...props}) => {
  const title = props.title || '';
  const clef = abcClefModifier(props.clef);
  if(!props.scientificNotes){
    return <Abcjs
    abcNotation={`%%staffwidth 200\nL:4/4\nK:C ${clef}\nT:${title}|`}
    parserParams={{}}
    engraverParams={{ responsive: 'resize' }}
    renderParams={{ viewportHorizontal: false }}
  />
  }
  const scientificNotes = props.clef === 'f'
    ? shiftToBassClefRange(props.scientificNotes)
    : props.scientificNotes;
  const abcArray = scientificNotes.map(scientificToAbcNotation);
  let abcNotes = abcArray.map((value, index) => {
    if(index>0 && value.length===1 && abcArray[index-1].endsWith(value)){
      return "="+value;
    }
    return value;
  });

  return <Abcjs
    abcNotation={`%%staffwidth 170\nL:1/8\nK:C ${clef}\nT:${title}\n${abcNotes.join('')}|`}
    parserParams={{}}
    engraverParams={{ responsive: 'resize' }}
    renderParams={{ viewportHorizontal: false }}
  />
}
export default AbcNotation;